import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CustomCursor from "../Components/CustomCursor";

export default function NewsThankyou() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="bg-black text-white min-vh-100 d-flex justify-content-center align-items-center flex-column text-center px-3"
    >
      <CustomCursor />

      <div className="thankyou-wrapper py-5">
        

        <h1 className="display-3 fw-bold anton ft1 ">
                                   <span className="text-warning2">Thank You! </span> 
                                </h1>


        <p className="fs-5 mb-4">
          We’ve received your message. Our team will get back to you shortly.
        </p>

        <div className="d-flex gap-3 justify-content-center flex-wrap">
          <Link
            to="/"
            className="btn btn-outline-light px-4 py-2 rounded-pill"
          >
            Go to Homepage
          </Link>

          {/* <Link
            to="/book-session"
            className="btn btn-warning px-4 py-2 rounded-pill"
          >
            Book Another Session
          </Link> */}
        </div>
      </div>
    </motion.div>
  );
}
